import { QRFC } from "./QRFC";

export class QReportIssueRFC extends QRFC {
  constructor() {
    super();
  }

  InitReportIssue(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
  }

  SetParams(org, user, username, useremail, toemail, message, status) {
    this.AddEncodedParameter("org", org);
    this.AddEncodedParameter("user", user);
    this.AddEncodedParameter("username", username);
    this.AddEncodedParameter("useremail", useremail);
    this.AddEncodedParameter("toemail", toemail);
    this.AddEncodedParameter("message", message);
    this.AddEncodedParameter("status", status);
    this.AddEncodedParameter("mode", "report");
  }

  GetCallName() {
    return "qreportissue";
  }

  DoTransactionComplete(response, callBackObj) {
    var r = response;
    var success = true;
    if (r == "failure") success = false;
    callBackObj.IssueReported(success, r);
  }
}
